import React from 'react';
import './button-add.css';

class ButtonAdd extends React.Component{
  render () {
    return (
        <a href="#" onClick={this.props.myClick} className="button-add js-button-add"><i className="fas fa-plus"></i></a>
    );
  }
};

export default ButtonAdd;



// WEBPACK FOOTER //
// ./src/components/form/ButtonAdd.js